export enum OrganizationTypeId {
    Unknown = 0,
    School = 1,
    Company = 2,
}

export interface Category {
    id: OrganizationTypeId;
    name: string;
}

export interface OrganizationV2Minimal {
    id: number;
    title: string;
}

export interface OrganizationV2 {
    id: number;
    parentCompanyId: number | null;
    title: string;
    description: string;
    webAddress: string;
    logo: string;
    countryCode: string;
    category: Category;
    visibilityMode: number;
}

export interface HierarchyItem {
    id: number;
    children?: HierarchyItem[];
}

export interface OrganizationHierarchy {
    root: number;
    tree: HierarchyItem;
    size: number;
    result: { [key: string]: OrganizationV2 | OrganizationV2Minimal };
}
